import {
  Activity,
  Anchor,
  ArrowLeftRight,
  Flag,
  List,
  PiggyBank,
  Rocket,
  Scale,
  Scissors,
  Sigma,
  TrendingUp,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

// Nightingale 5.0 sub tabs — order is the owner's (2026-10-30). Each is a sidebar
// entry with its own URL (/nightingale-5/<slug>), empty until its algo is built.
export const NIGHTINGALE_5_TABS: { slug: string; label: string; icon: LucideIcon }[] = [
  { slug: 'trades', label: 'Trades', icon: List },
  { slug: 'first-hook', label: 'First Hook', icon: Anchor },
  { slug: 'trade-initiation', label: 'Trade Initiation', icon: Rocket },
  { slug: 'pruning', label: 'Pruning', icon: Scissors },
  { slug: 'maximisation', label: 'Maximisation', icon: TrendingUp },
  { slug: 'lambda-algo', label: 'Lambda Algo', icon: Sigma },
  { slug: 'ps-algo', label: 'PS Algo', icon: Activity },
  { slug: 'cluster-action', label: 'Cluster Action', icon: PiggyBank },
  { slug: 'least-action', label: 'Least Action', icon: Scale },
  { slug: 'expiry-transfer', label: 'Expiry Transfer', icon: ArrowLeftRight },
  { slug: 'last-action', label: 'Last Action', icon: Flag },
];
